import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import { AnalyticsService } from '../../services/analytics.service';
import './unsubscribe.component.scss';

export class Unsubscribe extends Base {

	containerUnsubscribe :any;
	containerNotValid: any;
	containerChanged: any;
	containerCancelled: any;
	containerLoader: any;

	btnChange: any;
	btnUnsubscribe: any;

	checkboxes: any;
	checkboxesSelected: any;

	constructor(element: Element){

		super(element);

	}

	init(){
		
		this.containerUnsubscribe = this.element.querySelector('.unsubscribe__container--change');
		this.containerNotValid = this.element.querySelector('.unsubscribe__container--notvalid');
		this.containerChanged = this.element.querySelector('.unsubscribe__container--changed');
		this.containerCancelled = this.element.querySelector('.unsubscribe__container--cancelled');
		this.containerLoader = this.element.querySelector('.unsubscribe__container--loader');

		this.checkboxes = Array.from(this.element.querySelectorAll('.js-newsletter-modal-checkbox'));
		this.btnChange = this.element.querySelector('.unsubscribe__button--change');
		this.btnUnsubscribe = this.element.querySelector('.unsubscribe__button--unsubscribe');
		this.checkboxesSelected = [];

		TooltipsService.initTooltips();

	}

	bindEvents() {

		this.btnChange.addEventListener('click', (event)=>{

			const element = event.target;
			const form = element.closest('form');
			this.unsubscribeTopics(form);

		});

		this.btnUnsubscribe.addEventListener('click', (event)=>{

			const element = event.target;
			const form = element.closest('form');
			this.unsubscribe(form);

		});

	}

	unsubscribeTopics(form: any) {

		this.containerUnsubscribe.classList.remove('d-block');
		this.containerNotValid.classList.remove('d-block');
		this.containerChanged.classList.remove('d-block');
		this.containerCancelled.classList.remove('d-block');
		this.containerLoader.classList.add('d-block');

		let operation: any = "unsubscribe_topics";	
		let formId: any = form.querySelector('input.js-unsubscribe-formid').value;	
		let subId: any = form.querySelector('input.js-unsubscribe-subid').value;
		let siteName: any = form.querySelector('input.js-unsubscribe-sitename').value;	
		let topics: any = "";

		this.checkboxes.map((item) => {
			if(item.checked) {
				this.checkboxesSelected.push(item.value);
			}
		});
		
		for (let index = 0; index < this.checkboxesSelected.length; index++) {
			const topic = this.checkboxesSelected[index];
			if((index + 1) === this.checkboxesSelected.length){
				topics += topic;
			}else{
				topics += topic + ",";
			}
		}

		let postData = '';
		if (operation) {
			postData += 'operation=' + operation + '&';
		}
		if (formId) {
			postData += 'formId=' + formId + '&';
		}
		if (subId) {
			postData += 'subId=' + subId + '&';
		}
		if (siteName) {
			postData += 'site=' + siteName + '&';
		}
		if (topics) {
			postData += 'topics=' + topics + '&';
		}

		let analyticsService = new AnalyticsService();
		let url = "/services/NewsLetterSubscription.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {

			this.containerLoader.classList.remove('d-block');

			if(response.data.result) {

				let result = response.data.result;

				if(result.indexOf('updated') !== -1) {

					analyticsService.dtmFormComplete('complete', response.data.subscriberId);
					this.containerUnsubscribe.classList.remove('d-block');
					this.containerChanged.classList.add('d-block');

				}else{

					this.containerUnsubscribe.classList.remove('d-block');
					this.containerNotValid.classList.add('d-block');

				}

			}else{

				this.containerUnsubscribe.classList.remove('d-block');
				this.containerNotValid.classList.add('d-block');
				
			}

		}).catch(error => {

			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			console.log(error);
			this.containerLoader.classList.remove('d-block');
			this.containerUnsubscribe.classList.remove('d-block');
			this.containerNotValid.classList.add('d-block');

		});

	}

	unsubscribe(form: any) {

		this.containerUnsubscribe.classList.remove('d-block');
		this.containerNotValid.classList.remove('d-block');
		this.containerChanged.classList.remove('d-block');
		this.containerCancelled.classList.remove('d-block');
		this.containerLoader.classList.add('d-block');

		let operation: any = "unsubscribe";	
		let formId: any = form.querySelector('input.js-unsubscribe-formid').value;	
		let subId: any = form.querySelector('input.js-unsubscribe-subid').value;
		let siteName: any = form.querySelector('input.js-unsubscribe-sitename').value;	

		let postData = '';
		if (operation) {
			postData += 'operation=' + operation + '&';
		}
		if (formId) {
			postData += 'formId=' + formId + '&';
		}
		if (subId) {
			postData += 'subId=' + subId + '&';
		}
		if (siteName) {
			postData += 'site=' + siteName + '&';
		}

		let analyticsService = new AnalyticsService();
		let url = "/services/NewsLetterSubscription.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {

			this.containerLoader.classList.remove('d-block');

			if(response.data.result) {

				let result = response.data.result;

				if(result.indexOf('unsubscribed') !== -1) {
					
					if(localStorage.getItem('sbgNewsletterSubscriberId')){
						localStorage.removeItem('sbgNewsletterSubscriberId');
					}
					analyticsService.dtmFormComplete('complete', response.data.subscriberId);
					this.containerUnsubscribe.classList.remove('d-block');
					this.containerCancelled.classList.add('d-block');

				}else{

					this.containerUnsubscribe.classList.remove('d-block');
					this.containerNotValid.classList.add('d-block');

				}

			}else{

				this.containerUnsubscribe.classList.remove('d-block');
				this.containerNotValid.classList.add('d-block');
				
			}

		}).catch(error => {

			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			console.log(error);
			this.containerLoader.classList.remove('d-block');
			this.containerUnsubscribe.classList.remove('d-block');
			this.containerNotValid.classList.add('d-block');

		});

	}

}


// WEBPACK FOOTER //
// ./components/unsubscribe/unsubscribe.component.ts